import { SiNoEnum } from "../enum/si-no-enum";
import { TipoAnagraficaCampoSpecificoEnum } from "../enum/tipo-anagrafica-campo-specifico-enum";
import { TipoCampoSpecificoEnum } from "../enum/tipo-campo-specifico-enum";

export class CampoSpecificoFascicolazioneVO {
  nome: string;
  obbligatorio: SiNoEnum;
  nomeAnagrafica: string;
  ripetibile: SiNoEnum;
  tipoAnagrafica: TipoAnagraficaCampoSpecificoEnum;
  idAnagrafica: string;
  tipoCampo: TipoCampoSpecificoEnum;
  codice: string;
  tipoDato: string;
}
